module.exports = __webpack_public_path__ + "img/cura_layers.a10892ea.gif";